import React from 'react';
import ApprovalPanel from './ApprovalPanel';
import OldApprovalItem from './old/ApprovalItem';
import ApprovalItem from './new/ApprovalItem';
import * as helper from '../util/helper';
import { BasicModal, Loading } from '@beisen/chaos-ui';
import transLoader from '@beisen/i18n-translation-loader';

const defaultTranslation = {
    pageError: '页面错误',
    viewFlowChart: '查看流程图',
    modalTitle: '即将跳转',
    modalMsg: '确定查看流程图？',
    flowChartTitle: '全部流程',
    cancel: '取消',
    confirm: '确定',
    completed: '已完成',
    progress: '进行中',
    unstart: '未开始',
    viewAll: '查看全部',
    canceled: '已取消',
    approved: '已审批',
    unapproved: '未审批',
    terminated: '已终止',
    spread: '展开',
    fold: '收起',
    num: '等$count人'
};
class ApprovalList extends React.Component {
	constructor(props) {
		super(props);
        this.state = {
            showModal: false
            ,showFlowChart: false
            ,activitys: []
            ,isNewVersion: false
        };
        this.closePanel = this.closePanel.bind(this);
        this.goToFlowChart = this.goToFlowChart.bind(this);
        this.tapReadmore = this.tapReadmore.bind(this);
        this.setnextLine = this.setnextLine.bind(this);
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            pageError: 'pageNotice.pageError',
            viewFlowChart: 'approval.viewFlowChart',
            modalTitle: 'approval.modalTitle',
            modalMsg: 'approval.modalMsg',
            flowChartTitle: 'approval.flowChartTitle',
            cancel: 'common.cancel',
            confirm: 'common.confirm',
            completed: 'approval.completed',
            progress: 'approval.progress',
            unstart: 'approval.unstart',
            viewAll: 'approval.viewAll',
            canceled: 'approval.canceled',
            approved: 'approval.approved',
            unapproved: 'approval.unapproved',
            terminated: 'approval.terminated',
            spread: 'approval.spread',
            fold: 'approval.fold',
            num: 'approval.num'
        }), props.translation);
	}

    componentDidMount() {
        const { translation } = this;
        let FetchUrl = '/api/v1/WF/FlowChart/GetMobileFowChartSnapshot?processInstanceId=' + this.props.processInstanceId;
        const successCallBack = function(response) {
            const { activitys = [], isNewVersion, flowChartUrl } = response;
            if(activitys.length > 0) {
                this.setState({ activitys: this.formatData(activitys,isNewVersion), isNewVersion: isNewVersion, flowChartUrl: flowChartUrl });
            }
        }.bind(this);
        const failureCallBack = function(error) {
            let tipInfo = { message: error.message || translation.pageError, type: 'error' };
            if (error.isOffLine) {
                error['type'] = 'error';
                tipInfo = error;
            }
            this.props.showTip(tipInfo);
        }.bind(this);
        FetchUrl = helper.ajaxUrlCompletionInCachePage(FetchUrl);
        window.CommonFetch && window.CommonFetch(FetchUrl, {}, successCallBack, failureCallBack);
    }

    tapReadmore() {
        //pc端页面url
        this.setState({ showModal: true });
    }

    getSymbol(url) {
		return url.indexOf('?') >= 0 ? '&' : '?';
	}
    getFlowUrl(url) {
        if(!url) return;
        const decodeUrl = decodeURIComponent(this.state.flowChartUrl);
		const params = `height=${window.innerHeight}&_width=${window.innerWidth}px&_isMobile=true`;

		const hash = decodeUrl.split('#/')[1];
		const originUrl = decodeUrl.split('#/')[0];
		// 如果URL上有路由并且路由后没有 ? 参数 则将参数追加到 #/前面
		if(decodeUrl.indexOf('#/') >= 0) {
			url = (hash.indexOf('?') > -1) ? `${url}&${params}` : `${originUrl}${this.getSymbol(originUrl)}${params}#/${hash}`;
		}else {
			url = `${url}${this.getSymbol(decodeUrl)}${params}`;
        }
        return url;
    }

    goToFlowChart() {
        this.setState({
            showFlowChart: true,
            showModal: false
        },() => {
            // 2019-04-29 注意 目前仅在italent ios 中采取这种方式 。tita由于壳子问题保持原状 tita下次上线修复 会通知咱们 再把这块判断放开
            window.env.platform.iTalentIOS && helper.openUrlInNewWindow({ title: this.translation.flowChartTitle },this.getFlowUrl(this.state.flowChartUrl));
        });
    }

    closePanel() {
        this.setState({ showModal: false, showFlowChart: false });
    }

    formatData(datas,isNewVersion) {
         let activitys = Object.assign([], datas);
         activitys.forEach((value,index) => {
            let names = '';
            if(value['assignes'] && value['assignes'].length > 0) {
                value['assignes'].map((item,index) => {
                    if(index >= 1 && isNewVersion && value.activityType == 3) return;
                    if(index >= 2 && isNewVersion) return;
                    names = (index == 0) ? item.name : (names + ',' + item.name);
                });
            }
            value['assignesNames'] = names;
         });
         return activitys;
    }

    getStatusArr() {
        let statusArr = [];
        this.state.activitys.map((item,index) => {
            statusArr.push({ index: index, status: item.status, isStart: item.isStart, isEnd: item.isEnd });
        });
        return statusArr;
    }

    setnextLine(index) {
        this.state.activitys[index]['setLine'] = index + 1;
        this.setState({ update: true });
    }

    renderApprovalItem(data,index) {
        const statusArr = this.getStatusArr();
        return this.state.isNewVersion ? <ApprovalItem setNextLine={this.setnextLine}
                                                        setLine={data.setLine}
                                                        statusArr={statusArr}
                                                        itemInfo={data}
                                                        key={index}
                                                        tapReadmore={this.tapReadmore}
                                                        index={index}
                                                        translation={this.translation} />
                                        : <OldApprovalItem itemInfo={data} key={index} tapReadmore={this.tapReadmore} index={index} translation={this.translation} />;
    }

	render() {
        const { translation } = this;
        if(this.state.activitys && this.state.activitys.length > 0) {
            return (<div className='process-list' ref="approvalList" style={this.props.style}>
                       {this.state.activitys.map((data,index) => {
                            return this.renderApprovalItem(data,index);
                        })}
                        {this.state.isNewVersion ? <div className="approval-item-workflow" onTouchTap={this.tapReadmore}>{translation.viewFlowChart}</div> : null}
                        {!window.env.platform.iTalentIOS && this.state.showFlowChart ? <ApprovalPanel translation={this.translation} closePanel={this.closePanel} url={this.state.flowChartUrl} /> : null}
                        <BasicModal visible={this.state.showModal}
                                    animation="zoom"
                                    maskAnimation="fade"
                                    title={translation.modalTitle}
                                    onClose={this.closePanel}
                                    footer={[
                                        {
                                            text: translation.cancel
                                            ,onTouchTap: this.closePanel
                                        }
                                        ,{
                                            text: translation.confirm
                                            ,onTouchTap: this.goToFlowChart
                                        }
                                    ]}>
                            {translation.modalMsg}
                        </BasicModal>
                </div>);
        }
        return <Loading />;
    }
}

export default ApprovalList;



// WEBPACK FOOTER //
// ./src/components/Approval/ApprovalList.js